import React, { useState } from "react"
import { Section, HeadingTwo } from "../elements"
import { accentSecondary, breakpoint4k } from "../variables"
import styled from "styled-components"
import { motion, AnimatePresence } from "framer-motion"
import Illustration from "../components/illustration"

const svgVariants = {
  closed: {
    rotate: -90,
  },
  open: {
    rotate: 0,
  },
}

const answerVariants = {
  visible: {
    x: 0,
    opacity: 1,
  },
  hidden: {
    x: -20,
    opacity: 0,
  },
}

const Accordian = ({ slice }) => {
  const { primary, items } = slice
  const [currentQuestion, setCurrentQuestion] = useState(null)

  return (
    <AccordianSection
      padding="69px 20px 184px 20px"
      paddingMd="105px 0px 184px 0px"
      minHeight="100vh"
    >
      <HeadingTwo
        fontSize="29px"
        textAlign="center"
        padding="0 0 76px 0"
        paddingMd="0 0 110px 0"
      >
        {primary.title.text}
      </HeadingTwo>
      <QuestionContainer>
        {items.map(({ question, answer }, i) => (
          <Question
            key={i}
            onClick={() =>
              i !== currentQuestion
                ? setCurrentQuestion(i)
                : setCurrentQuestion(null)
            }
            initial={{ height: "fit-content" }}
            animate={{ height: currentQuestion === i ? "auto" : 80 }}
          >
            <div className="top">
              <p>{question.text}</p>
              <motion.svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="11"
                viewBox="0 0 22 11"
                variants={svgVariants}
                initial="closed"
                animate={currentQuestion === i ? "open" : "closed"}
              >
                <path
                  id="Polygon_3"
                  data-name="Polygon 3"
                  d="M11,0,22,11H0Z"
                  transform="translate(22 11) rotate(180)"
                  fill="#aca097"
                />
              </motion.svg>
            </div>
            <AnimatePresence>
              {currentQuestion === i && (
                <motion.p
                  className="answer"
                  variants={answerVariants}
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                >
                  {answer.text}
                </motion.p>
              )}
            </AnimatePresence>
          </Question>
        ))}
      </QuestionContainer>
      <Illustration placement="right" />
    </AccordianSection>
  )
}

export default Accordian

const AccordianSection = styled(Section)`
  min-height: 100vh;
  position: relative;
  overflow: hidden;

  @media (min-width: ${breakpoint4k}) {
    min-height: 80vh;
  }
`

const QuestionContainer = styled(motion.div)`
  max-width: 919px;
  margin: 0 auto;
  user-select: none;
`

const Question = styled(motion.div)`
  margin-top: 5px;
  padding: 19px 24px;
  background: ${accentSecondary};
  overflow: hidden;

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      font-size: 17px;
      font-weight: 600;
      margin: 10px;
    }
  }

  .answer {
    font-size: 17px;
    line-height: 24px;
    margin: 10px;
  }

  svg {
    transform-origin: center;
    transform: rotate(-90deg);
  }

  .content {
    display: flex;
    flex-direction: column;
  }
`

